import { render } from "./videoLst.vue?vue&type=template&id=5015889e&scoped=true"
import script from "./videoLst.vue?vue&type=script&lang=js"
export * from "./videoLst.vue?vue&type=script&lang=js"

import "./videoLst.vue?vue&type=style&index=0&id=5015889e&scoped=true&lang=css"

import exportComponent from "F:\\2021年交接\\前端嘉俊交接\\项目\\新重本紫腾重构\\zbzt-website-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5015889e"]])

export default __exports__